export default {
  init() {

    $('.companiesed').slick({
      slidesToShow : 5,
      slidesToScroll : 5,
      infinite: true,
      autoplay : false,
      arrows: false,
      responsive: [
       {
         breakpoint: 950,
         settings: {
           slidesToShow: 3,
           slidesToScroll: 3,
         },
       },
       {
         breakpoint: 762,
         settings: {
           slidesToShow: 2,
           slidesToScroll: 2,
         },
       },
     ],
    });

    // Bring logo into first animation
    $('.companiesed .slick-active').addClass('show-logo');

    // Get the current slide
    window.setInterval(function(){
      //var currentSlide = $('.companiesed').slick('slickCurrentSlide');
      $('.companiesed .slick-active').removeClass('show-logo');

      setTimeout(function(){
        $('.companiesed').slick('slickNext');
      }, 500);

      setTimeout(function(){
        $('.companiesed .slick-active').addClass('show-logo');
      }, 1000);


    }, 5000);

    // On before slide change
    // $('.companiesed').on('beforeChange', function(){
    //   $('.companiesed .slick-slide').fadeOut();
    // });


    // JavaScript to be fired on the home page
    // window.setInterval(function(){
    //   /// call your function here
    //   //var activeList = shuffle($("ul.companies li img.active-showing")).slice(0, X);
    //
    //   //var isShowing = [];
    //
    //   var inActiveList = [];
    //
    //   $('ul.companies li.no-show').each(function(){
    //     var img = $(this).find('.company-logo').attr('src');
    //     inActiveList.push(img);
    //   });
    //
    //   var randInActive = Math.floor(Math.random()*inActiveList.length);
    //
    //   var len = $("ul.companies li.active-showing").length;
    //   var random = Math.floor( Math.random() * len ) + 1;
    //   $("ul.companies li.active-showing").eq(random).addClass('changing');
    //
    //   setTimeout(function(){
    //     $("ul.companies li.active-showing").eq(random).find('img').attr('src', inActiveList[randInActive]);
    //     $("ul.companies li.active-showing").eq(random).removeClass('changing');
    //   }, 1500);
    //
    // }, 5000);

    $(document).ready(function(){
      if($(".js-card")) {
        $(".js-card").hover(
          function() {
            $(this).addClass("active");
            $(this).siblings().removeClass("active");
          },
          function() {
            $(this).removeClass("active");
          }
        );
      }

    });


  },


  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js